import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import Navbar from './components/Navbar';
import Careers from './pages/Careers';
import WhoWe from './landingpages/whowe';
import Coreservices from './landingpages/coreservices';
import WhyChoose from './landingpages/whychoose';
import Testimonial from './landingpages/testimonial';
import CTASection from './landingpages/readyland';
import LandingHero from './landingpages/landinghero';
import Contact from './contact/Contact';
import Footer from './components/Footer';
import AboutUs from './Ourservices/AboutUs';
import Services from './Ourservices/Services';
import TestimonialsPage from './Ourservices/Testimonials';
import Investor from './pages/Investor';

function AppContent() {
  const location = useLocation();
  const isInvestorPage = location.pathname === '/investor';

  return (
    <div className="App">
      {/* <PageLoader /> */}
      {!isInvestorPage && <Navbar />}
      
      <Routes>
        {/* LANDING PAGE ROUTE */}
        <Route
          path="/"
          element={
            <>
              <LandingHero />
              <WhoWe />
              <Coreservices />
              <WhyChoose />
              <Testimonial />
              <CTASection />
              <Footer />
            </>
          }
        />
        
        {/* OTHER ROUTES */}
        <Route path="/about" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/testimonials" element={<TestimonialsPage />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/investor" element={<Investor />} />
        <Route path="/contact" element={<Contact />} />
        
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
